var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import ZendeskHelp from './ZendeskHelp';
var SimplePanel = function (_a) {
    var title = _a.title, className = _a.className, article = _a.article, bodyClass = _a.bodyClass, children = _a.children, buttons = _a.buttons, onClick = _a.onClick;
    return (_jsxs("div", __assign({ className: classNames('panel', className) }, { children: [_jsxs("div", __assign({ className: "panel-heading", onClick: onClick }, { children: [_jsxs("h3", __assign({ className: "panel-title" }, { children: [title, article && _jsx(ZendeskHelp, { article: article })] })), _jsx("div", __assign({ className: "panel-buttons" }, { children: buttons }))] })), children ? _jsx("div", __assign({ className: classNames('panel-body', bodyClass) }, { children: children })) : null] })));
};
export default SimplePanel;
